import { getError, isLoading } from '/b2b/authentication/state/Auth.selectors';
import {
    getId,
    hasPermission as userHasPermission,
} from '/b2b/authentication/state/user/AuthUser.selectors';

import Component from './Account.component';
import { connect } from 'react-redux';
import { fetchUserDetails } from './Account.commands';
import { getEntityById } from '/b2b/users/state/db/User.selectors';

const mapStateToProps = state => {
    const userId = getId(state);

    const hasPermissionToUpdateCognitoMFA = userHasPermission(state, {
        toPerform: 'updateCognito',
        on: 'account.mfa',
    });
    const hasPermissionToUpdateCognitoPassword = userHasPermission(state, {
        toPerform: 'updateCognito',
        on: 'account.password',
    });

    return {
        hasPermissionToUpdateCognitoMFA,
        hasPermissionToUpdateCognitoPassword,
        isLoading: isLoading(state),
        error: getError(state),
        userId,
        details: getEntityById(state, userId),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUserDetails: userId => () => dispatch(fetchUserDetails({ userId })),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
